import React from 'react'

import { useDashboardFeatureFlags } from '@components'
import { Dashboard, PageLayout } from '@components/common'
import { SECTION_NAMES } from '@constants/sectionNames'
import { HeadContent } from '@fourthwall/components'

import { AnalyticsToolbar, PrecisionSelect, RangeSelect } from '../../modules/AnalyticsParams'
import {
  AnalyticsReportsData,
  type AnalyticsReportsDataProps,
} from './components/AnalyticsReportsData/AnalyticsReportsData'

type ReportsDownloadViewProps = {
  list: AnalyticsReportsDataProps['list']
  table: AnalyticsReportsDataProps['table']
}

export const AnalyticsReportsView = ({ list, table }: ReportsDownloadViewProps) => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  return (
    <>
      <HeadContent title={SECTION_NAMES.analyticsReports} />
      <PageLayout size={dashboardFeatureFlags.analyticsTabs.enabled ? 'full' : undefined}>
        <Dashboard.Section name={SECTION_NAMES.analyticsReports}>
          <AnalyticsToolbar>
            <RangeSelect />
            <PrecisionSelect />
          </AnalyticsToolbar>
          <AnalyticsReportsData list={list} table={table} />
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
